import { parseMoney } from './money';

const absoluteUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const base = process.env.REACT_APP_API_URL || window.location.origin;
  return `${base.replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;
};

export const normalizeMainProductForPayment = (item = {}, quantity = 1) => ({
  productSource: 'main',
  productId: String(item.id || item.productId || item.sku || ''),
  productName: item.title || item.name || 'Product',
  productImageUrl: absoluteUrl(item.thumbnail || item.image || item.product_image_url || ''),
  productUrl: window.location.href,
  unitPrice: parseMoney(item.price || item.gen_price),
  quantity,
  currency: 'NGN',
});

export const normalizeOximoProductForPayment = (product = {}, quantity = 1) => ({
  productSource: 'oximo',
  productId: String(product.symbol || ''),
  productName: product.short_name_en || product.symbol || 'Oximo Product',
  productImageUrl: product.foto_1 || '',
  productUrl: window.location.href,
  unitPrice: parseMoney(product.price),
  quantity,
  currency: 'NGN',
});

export const normalizeAliProductForPayment = (product = {}, productId, quantity = 1, selectedShippingOption = null) => {
  const sku = product?.ae_item_sku_info_dtos?.ae_item_sku_info_d_t_o?.[0] || {};
  const title = product?.ae_item_base_info_dto?.subject || 'AliExpress Product';
  const image = product?.ae_multimedia_info_dto?.image_urls?.split(';')?.filter(Boolean)?.[0] || '';
  return {
    productSource: 'aliexpress',
    productId: String(productId || product?.ae_item_base_info_dto?.product_id || ''),
    productName: title,
    productImageUrl: image,
    productUrl: window.location.href,
    unitPrice: parseMoney(sku.offer_sale_price),
    quantity,
    currency: 'NGN',
    shippingMethod: selectedShippingOption?.method || '',
    shippingFee: selectedShippingOption?.fee || 0,
    shippingEta: selectedShippingOption?.eta || '',
    shippingOptionSnapshot: selectedShippingOption || {},
  };
};

export const normalizeAsplProductForPayment = (product = {}, quantity = 1) => ({
  productSource: 'aspl',
  productId: String(product.id || product.reference || product.aspl_id || ''),
  productName: product.name || product.reference || 'ASPL Product',
  productImageUrl: product.photos?.[0] || '',
  productUrl: window.location.href,
  unitPrice: parseMoney(product.priceNGN),
  quantity,
  currency: 'NGN',
});
